var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "messages-filter" } },
    [
      _c(
        "f7-list",
        [
          _c(
            "f7-list-item",
            { class: _vm.additionalClass },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start no-gutter w-100" },
                [
                  _c(
                    "div",
                    { staticClass: "form-group mr-2" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("refreshInbox")
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa fa-rotate-right fs-14px" })]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.mode != 5
                    ? _c(
                        "div",
                        { staticClass: "form-group mx-2" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("extractCSV")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-light fa-upload fs-14px",
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "fab-label" }, [
                                _vm._v(_vm._s(_vm.$t("common.extract_list"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode != 5
                    ? _c(
                        "div",
                        { staticClass: "form-group mx-2" },
                        [
                          _c(
                            "b-button-group",
                            { staticClass: "mt-sm-0" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: _vm.role === 2 ? "primary" : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.role = 2
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.all")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: _vm.role === 1 ? "primary" : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.role = 1
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.sent")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: _vm.role === 0 ? "primary" : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.role = 0
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.received")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "form-group mx-2" },
                        [
                          _c(
                            "b-button-group",
                            { staticClass: "mt-sm-0" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: _vm.section === 1 ? "primary" : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.section = 1
                                      _vm.applyFilter(5)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("filter.feature.inbound"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: _vm.section === 2 ? "primary" : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.section = 2
                                      _vm.applyFilter(5)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("filter.feature.outbound"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm.showListGroupPanel() && _vm.hasRight("rtp_group_create")
                    ? _c(
                        "b-col",
                        {
                          staticClass: "p-0",
                          attrs: { cols: "1", offset: "3" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              class:
                                _vm.modeFilter === 1
                                  ? "navbar-button-selected"
                                  : "navbar-button",
                              attrs: { variant: "primary", size: "sm" },
                              on: {
                                click: function ($event) {
                                  return _vm.applyFilter(1)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("filter.tab_unit")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showListGroupPanel() && _vm.hasRight("rtp_group_create")
                    ? _c(
                        "b-col",
                        { staticClass: "p-0", attrs: { cols: "1" } },
                        [
                          _c(
                            "b-button",
                            {
                              class:
                                _vm.modeFilter === 2
                                  ? "navbar-button-selected"
                                  : "navbar-button",
                              attrs: { variant: "primary", size: "sm" },
                              on: {
                                click: function ($event) {
                                  return _vm.applyFilter(2)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("filter.tab_group")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showButtonCreateSupplier()
                    ? _c(
                        "b-col",
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("createSupplier")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-light fa-plus fs-14px",
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "fab-label" }, [
                                _vm._v(_vm._s(_vm.$t("suppliers.sup"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showButtonCreateVerify()
                    ? _c(
                        "b-col",
                        {
                          attrs: {
                            cols: "12",
                            sm: "5",
                            md: "4",
                            xl: "4",
                            offset: "0",
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2 mt-3 mt-xl-0",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("createVerify")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-light fa-plus fs-14px",
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "fab-label" }, [
                                _vm._v(_vm._s(_vm.$t("verifications.verify"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showButtonImportLot()
                    ? _c(
                        "b-col",
                        {
                          staticClass: "showLargeScreenOnly",
                          attrs: { cols: "2" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("refreshInbox")
                                },
                              },
                            },
                            [
                              _c("i", {
                                attrs: { f7: "fa-light fa-upload fs-14px" },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "fab-label" }, [
                                _vm._v(_vm._s(_vm.$t("common.imprt_list"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.displayFilter
                    ? _c("b-col", {
                        staticClass:
                          "d-flex flex-row-reverse showLargeScreenOnly mt-25px",
                        attrs: { cols: "5", offset: "7" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "f7-list-item",
            {
              staticClass: "showLargeScreenOnly",
              class: {
                "filter-item-section": true,
                "d-none": !_vm.displayFilter,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "min-w-100" },
                [
                  _vm.showFilterNorm()
                    ? _c(
                        "b-row",
                        { staticClass: "min-w-100" },
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "filter-item col-3 mb-3 text-truncate",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title text-ellipsis",
                                    attrs: {
                                      title: _vm.$t("filter.standard_title"),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("filter.standard_title"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "filter-item-content d-flex pt-2",
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.normId,
                                            expression: "normId",
                                          },
                                        ],
                                        staticClass:
                                          "z-2 position-relative cursor fs-14px-important h-100 mw-none select-appearance",
                                        class: { "text-muted": !_vm.normId },
                                        attrs: { id: "norm-select" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.normId = $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            staticClass: "text-muted",
                                            attrs: { value: "" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "filter.selected_standard_none"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.normList, function (norm) {
                                          return _c(
                                            "option",
                                            { domProps: { value: norm.id } },
                                            [_vm._v(_vm._s(norm.label))]
                                          )
                                        }),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex row justify-content-start",
                      attrs: { cols: "9" },
                    },
                    [
                      _vm.showFilterSupplierId() && _vm.LMSGsupplierconfig
                        ? _c("div", { staticClass: "filter-item col-4 mb-3" }, [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("filter.supplier_id")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-item-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterSupplierId,
                                    expression: "filterSupplierId",
                                  },
                                ],
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete":
                                    _vm.filterSupplierId,
                                },
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t("filter.supplier_id"),
                                },
                                domProps: { value: _vm.filterSupplierId },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.filterSupplierId = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterSupplierSIREN()
                        ? _c("div", { staticClass: "filter-item col-4 mb-3" }, [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("common.srn")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-item-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterSiren,
                                    expression: "filterSiren",
                                  },
                                ],
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete": _vm.filterSiren,
                                },
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "common.srn_placeholder_supplier"
                                  ),
                                },
                                domProps: { value: _vm.filterSiren },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.filterSiren = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterSupplierName()
                        ? _c("div", { staticClass: "filter-item col-4 mb-3" }, [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(_vm._s(_vm.$t("common.social_reason"))),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-item-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterSupplierName,
                                    expression: "filterSupplierName",
                                  },
                                ],
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete":
                                    _vm.filterSupplierName,
                                },
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "filter.social_reason_placeholder"
                                  ),
                                },
                                domProps: { value: _vm.filterSupplierName },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.filterSupplierName = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterDoctype()
                        ? _c("div", { staticClass: "filter-item col-4 mb-3" }, [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(_vm._s("Type du document")),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "filter-item-content d-flex" },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.filterDocumentType,
                                        expression: "filterDocumentType",
                                      },
                                    ],
                                    ref: "selectDoctype",
                                    staticClass: "cursor fs-14px h-auto z-2",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.filterDocumentType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "IDCARD" } },
                                      [_vm._v("Carte d'identité")]
                                    ),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "RIB" } }, [
                                      _vm._v("RIB"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "Kbis" } }, [
                                      _vm._v("Kbis"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "fa-light fa-chevron-down cursor ml--20px z-1",
                                  attrs: { size: "17px", id: "status-chevron" },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterMsgId()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: { title: _vm.$t("filter.msgId") },
                                },
                                [_vm._v(_vm._s(_vm.$t("filter.msgId")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.msgId,
                                        expression: "msgId",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete": _vm.msgId,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t("filter.msgId"),
                                    },
                                    domProps: { value: _vm.msgId },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.msgId = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterEndToEndId()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t("filter.end_to_end_id"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("filter.end_to_end_id")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.endToEndId,
                                        expression: "endToEndId",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete":
                                        _vm.endToEndId,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "filter.end_to_end_id"
                                      ),
                                    },
                                    domProps: { value: _vm.endToEndId },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.endToEndId = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterReason()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: { title: _vm.$t("filter.reason") },
                                },
                                [_vm._v(_vm._s(_vm.$t("filter.reason")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.reason,
                                        expression: "reason",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete": _vm.reason,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t("filter.reason"),
                                    },
                                    domProps: { value: _vm.reason },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.reason = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterStatus() && _vm.serviceId === "1"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title:
                                      _vm.serviceId === _vm.services.SUPPLIERS
                                        ? _vm.$t("common.kyc_status")
                                        : _vm.$t("common.status.status_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.serviceId === _vm.services.SUPPLIERS
                                          ? _vm.$t("common.kyc_status")
                                          : _vm.$t("common.status.status_label")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between p-1 pt-2",
                                  attrs: {
                                    id:
                                      "status-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class:
                                        "fixed-span-size " +
                                        (_vm.statusDisplay.nb > 0
                                          ? "filter-item-input-complete"
                                          : ""),
                                    },
                                    [_vm._v(_vm._s(_vm.statusDisplay.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "status-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "status-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    title: _vm.$t(
                                      "filter.selected_status_none"
                                    ),
                                    triggers: "focus",
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "span",
                                      { key: "allStatus" },
                                      [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: {
                                              checked: _vm.allStatus(),
                                              value: true,
                                              "unchecked-value": false,
                                            },
                                            on: { change: _vm.checkAllStatus },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-normal fs-13px",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.allStatus()
                                                      ? _vm.$t(
                                                          "filter.all_uncheck"
                                                        )
                                                      : _vm.$t(
                                                          "filter.all_check"
                                                        )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("hr", { staticClass: "my-2 mx-m08" }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.arrayStatusList,
                                    function (categoryStatus, categoryName) {
                                      return _c(
                                        "div",
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "MoneyRoadcolorBlack",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "common.status.rtp_categories." +
                                                      categoryName
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.statusList,
                                            function (status, index) {
                                              return _c(
                                                "span",
                                                {
                                                  key: status.id + "-" + index,
                                                },
                                                [
                                                  _vm.showStatus(status) &&
                                                  categoryStatus.includes(
                                                    status.id
                                                  )
                                                    ? _c(
                                                        "b-form-checkbox",
                                                        {
                                                          attrs: {
                                                            value: 1,
                                                            "unchecked-value": 0,
                                                          },
                                                          model: {
                                                            value: status.state,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                status,
                                                                "state",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "status.state",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-normal fs-13px",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "common.status.rtp." +
                                                                      status.id
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterStatus() && _vm.serviceId !== "1"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title:
                                      _vm.serviceId === _vm.services.SUPPLIERS
                                        ? _vm.$t("common.kyc_status")
                                        : _vm.$t("common.status.status_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.serviceId === _vm.services.SUPPLIERS
                                          ? _vm.$t("common.kyc_status")
                                          : _vm.$t("common.status.status_label")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between p-1 pt-2",
                                  attrs: {
                                    id:
                                      "status-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "filter-item-input-complete":
                                          _vm.statusDisplay.nb > 0,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.statusDisplay.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "status-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "status-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    title: _vm.$t(
                                      "filter.selected_status_none"
                                    ),
                                    triggers: "focus",
                                    placement: "bottomright",
                                  },
                                },
                                _vm._l(
                                  _vm.statusList,
                                  function (status, index) {
                                    return _c(
                                      "span",
                                      { key: status.name + "-" + index },
                                      [
                                        _vm.showStatus(status)
                                          ? _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  value: 1,
                                                  "unchecked-value": 0,
                                                },
                                                model: {
                                                  value: status.state,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      status,
                                                      "state",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "status.state",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(status.label)),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterStatusKYC()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title ml-2px text-ellipsis",
                                  attrs: {
                                    title:
                                      _vm.serviceId === _vm.services.SUPPLIERS
                                        ? _vm.$t("common.kyc_status")
                                        : _vm.$t("common.status.status_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.serviceId === _vm.services.SUPPLIERS
                                          ? _vm.$t("common.kyc_status")
                                          : _vm.$t("common.status.status_label")
                                      ) +
                                      "\n              "
                                  ),
                                  _c("span", { staticClass: "color-red" }, [
                                    _vm._v("* "),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content d-flex" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.status,
                                          expression: "status",
                                        },
                                      ],
                                      staticClass:
                                        "cursor fs-13px h-auto z-2 color-grey-span-filterKYC",
                                      attrs: { id: "sel2" },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.status = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("acceptance.select_stat")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.statusKYC, function (status) {
                                        return _c(
                                          "option",
                                          {
                                            key: status.code,
                                            domProps: { value: status.code },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(status.label) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "fa-light fa-chevron-down cursor ml--20px z-1",
                                    attrs: {
                                      size: "17px",
                                      id: "status-chevron",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterStatusVerif()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title ml-2px text-ellipsis",
                                  attrs: {
                                    title:
                                      _vm.serviceId === _vm.services.SUPPLIERS
                                        ? _vm.$t("common.kyc_status")
                                        : _vm.$t("common.status.status_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.serviceId === _vm.services.SUPPLIERS
                                          ? _vm.$t("common.kyc_status")
                                          : _vm.$t("common.status.status_label")
                                      ) +
                                      "\n              "
                                  ),
                                  _c("span", { staticClass: "color-red" }, [
                                    _vm._v("* "),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content d-flex" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.status,
                                          expression: "status",
                                        },
                                      ],
                                      staticClass:
                                        "cursor fs-13px h-auto z-2 color-grey-span-filterKYC",
                                      attrs: { id: "sel2" },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.status = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("acceptance.select_stat")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.statusVerif,
                                        function (status) {
                                          return _c(
                                            "option",
                                            {
                                              key: status.code,
                                              domProps: { value: status.code },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(status.label) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "fa-light fa-chevron-down cursor ml--20px z-1",
                                    attrs: {
                                      size: "17px",
                                      id: "status-chevron",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterContactName()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: { title: _vm.$t("filter.cntct_name") },
                                },
                                [_vm._v(_vm._s(_vm.$t("filter.cntct_name")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.cdtrOrDbtrNm,
                                        expression: "cdtrOrDbtrNm",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete":
                                        _vm.cdtrOrDbtrNm,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "filter.cntct_name_placeholder"
                                      ),
                                    },
                                    domProps: { value: _vm.cdtrOrDbtrNm },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.cdtrOrDbtrNm = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterDebtorId()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: { title: _vm.$t("common.debtor_ibn") },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.debtor_ibn")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.debtorId,
                                        expression: "debtorId",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete":
                                        _vm.debtorId,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t("common.debtor_ibn"),
                                    },
                                    domProps: { value: _vm.debtorId },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.debtorId = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterDebtorIdProvider()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t(
                                      "requestToPay.provider_dbtor"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("requestToPay.provider_dbtor")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.debtorIdProvider,
                                        expression: "debtorIdProvider",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete":
                                        _vm.debtorIdProvider,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "requestToPay.provider_dbtor"
                                      ),
                                    },
                                    domProps: { value: _vm.debtorIdProvider },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.debtorIdProvider =
                                            $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterCreditorIdProvider()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t(
                                      "requestToPay.provider_crdtr"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("requestToPay.provider_crdtr")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.creditorIdProvider,
                                        expression: "creditorIdProvider",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete":
                                        _vm.creditorIdProvider,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "requestToPay.provider_crdtr"
                                      ),
                                    },
                                    domProps: { value: _vm.creditorIdProvider },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.creditorIdProvider =
                                            $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterTypeAction()
                        ? _c("div", { staticClass: "filter-item mb-3" }, [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(_vm._s(_vm.$t("filter.action_type"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "filter-item-content d-flex" },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.typeAction,
                                        expression: "typeAction",
                                      },
                                    ],
                                    ref: "selectTypeAction",
                                    staticClass: "cursor fs-14px h-auto z-2",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.typeAction = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("filter.action_type_choose")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "CREATE" } },
                                      [_vm._v(_vm._s(_vm.$t("history.CREATE")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "DELETE" } },
                                      [_vm._v(_vm._s(_vm.$t("history.DELETE")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "MODIFY" } },
                                      [_vm._v(_vm._s(_vm.$t("history.MODIFY")))]
                                    ),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "SEND" } }, [
                                      _vm._v(_vm._s(_vm.$t("history.SEND"))),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "CANCEL" } },
                                      [_vm._v(_vm._s(_vm.$t("history.CANCEL")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "ACCEPT" } },
                                      [_vm._v(_vm._s(_vm.$t("history.ACCEPT")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "REFUSE" } },
                                      [_vm._v(_vm._s(_vm.$t("history.REFUSE")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "MODIFY_AND_ACCEPT" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("history.MODIFY_AND_ACCEPT")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "ACCEPT_AND_PAY" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("history.ACCEPT_AND_PAY")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "PAY" } }, [
                                      _vm._v(_vm._s(_vm.$t("history.PAY"))),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "SAVE" } }, [
                                      _vm._v(_vm._s(_vm.$t("history.SAVE"))),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "UPLOAD" } },
                                      [_vm._v(_vm._s(_vm.$t("history.UPLOAD")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "UPLOAD_API" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("history.UPLOAD_API"))
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "fa-light fa-chevron_down cursor ml--20px z-1",
                                  attrs: { size: "17px", id: "status-chevron" },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterUser()
                        ? _c("div", { staticClass: "filter-item mb-3" }, [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(_vm._s("Utilisateur")),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-item-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.user,
                                    expression: "user",
                                  },
                                ],
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete": _vm.user,
                                },
                                attrs: {
                                  type: "text",
                                  placeholder: "Saisir l'identifiant",
                                },
                                domProps: { value: _vm.user },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.user = $event.target.value
                                    },
                                    function ($event) {
                                      return _vm.delayApplyFilter(
                                        _vm.modeFilter
                                      )
                                    },
                                  ],
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "filter-item col-4 mb-3" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "filter-item-title text-ellipsis",
                              attrs: {
                                title: _vm.$t("common.date_start_label"),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("common.date_start_label")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("datetime-picker-custom", {
                            staticClass: "z-1",
                            class: {
                              "filter-item-input": true,
                              "filter-item-input-complete": _vm.dateBegin,
                              "error-datepicker": _vm.dateBeginError,
                            },
                            attrs: {
                              format: "DD/MM/YYYY H:i:s",
                              customInputParentClass: "filter-item-content",
                              customInputClass: "w-100",
                              maxLength: 19,
                              placeholderValue: _vm.$t(
                                "common.datetime_picker_empty_date"
                              ),
                              inputIcon: "fa-solid fa-calendar",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.delayApplyFilter(_vm.modeFilter)
                              },
                            },
                            model: {
                              value: _vm.dateBegin,
                              callback: function ($$v) {
                                _vm.dateBegin = $$v
                              },
                              expression: "dateBegin",
                            },
                          }),
                          _vm._v(" "),
                          _vm.dateBeginError
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("errors.Data_format_invalid"))
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "filter-item col-4 mb-3" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "filter-item-title text-ellipsis",
                              attrs: { title: _vm.$t("common.date_end_label") },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("common.date_end_label")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("datetime-picker-custom", {
                            staticClass: "z-1",
                            class: {
                              "filter-item-input": true,
                              "filter-item-input-complete": _vm.dateEnd,
                              "error-datepicker": _vm.dateEndError,
                            },
                            attrs: {
                              format: "DD/MM/YYYY H:i:s",
                              customInputParentClass: "filter-item-content",
                              customInputClass: "w-100",
                              maxLength: 19,
                              placeholderValue: _vm.$t(
                                "common.datetime_picker_empty_date"
                              ),
                              inputIcon: "fa-solid fa-calendar",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.delayApplyFilter(_vm.modeFilter)
                              },
                            },
                            model: {
                              value: _vm.dateEnd,
                              callback: function ($$v) {
                                _vm.dateEnd = $$v
                              },
                              expression: "dateEnd",
                            },
                          }),
                          _vm._v(" "),
                          _vm.dateEndError
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("errors.Data_format_invalid"))
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showFilterFeature()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t("common.routing.feature"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("common.routing.feature")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between p-1 pt-2",
                                  attrs: {
                                    id:
                                      "feature-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class:
                                        "fixed-span-size " +
                                        (_vm.featureDisplay.nb > 0
                                          ? "filter-item-input-complete"
                                          : ""),
                                    },
                                    [_vm._v(_vm._s(_vm.featureDisplay.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "msgType-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "feature-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    title: _vm.$t(
                                      "filter.selected_feature_none"
                                    ),
                                    triggers: "focus",
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            value: true,
                                            "unchecked-value": false,
                                          },
                                          on: { change: _vm.checkAllFeature },
                                          model: {
                                            value: _vm.featureAll,
                                            callback: function ($$v) {
                                              _vm.featureAll = $$v
                                            },
                                            expression: "featureAll",
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.featureAll
                                                  ? _vm.$t("filter.all_uncheck")
                                                  : _vm.$t("filter.all_check")
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("hr", { staticClass: "my-2 mx-m08" }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.featureList,
                                    function (type, index) {
                                      return _c(
                                        "span",
                                        {
                                          key:
                                            _vm.$t(
                                              "filter.feature.feature_type." +
                                                type.id
                                            ) +
                                            "-" +
                                            index,
                                        },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              attrs: {
                                                value: 1,
                                                "unchecked-value": 0,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  _vm.featureChange()
                                                  _vm.delayApplyFilter(
                                                    _vm.modeFilter
                                                  )
                                                },
                                              },
                                              model: {
                                                value: type.state,
                                                callback: function ($$v) {
                                                  _vm.$set(type, "state", $$v)
                                                },
                                                expression: "type.state",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "filter.feature.feature_type." +
                                                        type.id
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterMsgType()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t("common.routing.message"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("common.routing.message")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between p-1 pt-2",
                                  attrs: {
                                    id:
                                      "msgType-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class:
                                        "fixed-span-size " +
                                        (_vm.messageTypeDisplay.nb > 0
                                          ? "filter-item-input-complete"
                                          : ""),
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.messageTypeDisplay.label)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "msgType-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "msgType-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    title: _vm.$t(
                                      "filter.selected_msg_type_none"
                                    ),
                                    triggers: "focus",
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            value: true,
                                            "unchecked-value": false,
                                          },
                                          on: { change: _vm.checkAllMsgType },
                                          model: {
                                            value: _vm.msgTypeAll,
                                            callback: function ($$v) {
                                              _vm.msgTypeAll = $$v
                                            },
                                            expression: "msgTypeAll",
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.msgTypeAll
                                                  ? _vm.$t("filter.all_uncheck")
                                                  : _vm.$t("filter.all_check")
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("hr", { staticClass: "my-2 mx-m08" }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.msgTypeList,
                                    function (type, index) {
                                      return _c(
                                        "span",
                                        {
                                          key:
                                            _vm.$t(
                                              "filter.orphan.message_type." +
                                                type.id
                                            ) +
                                            "-" +
                                            index,
                                        },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              attrs: {
                                                value: 1,
                                                "unchecked-value": 0,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  _vm.msgTypeChange()
                                                  _vm.delayApplyFilter(
                                                    _vm.modeFilter
                                                  )
                                                },
                                              },
                                              model: {
                                                value: type.state,
                                                callback: function ($$v) {
                                                  _vm.$set(type, "state", $$v)
                                                },
                                                expression: "type.state",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "filter.orphan.message_type." +
                                                        type.id
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterInitParty()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: { title: _vm.$t("orphan.init_party") },
                                },
                                [_vm._v(_vm._s(_vm.$t("orphan.init_party")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.initParty,
                                        expression: "initParty",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete": _vm.msgId,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t("orphan.init_party"),
                                    },
                                    domProps: { value: _vm.initParty },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.initParty = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterMsgIdOrphan()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-3 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t("orphan.msg_identifier"),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("orphan.msg_identifier"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.msgId,
                                        expression: "msgId",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete": _vm.msgId,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "orphan.msg_identifier"
                                      ),
                                    },
                                    domProps: { value: _vm.msgId },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.msgId = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex flex-row-reverse",
                      class: _vm.modeFilter === 3 ? "mt-5" : "mt-4",
                      attrs: { cols: "3" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm" },
                          on: {
                            click: function ($event) {
                              return _vm.applyFilter(_vm.modeFilter)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("filter.fltr")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2 d-inline d-xl-none",
                          attrs: { size: "sm", disabled: !_vm.hasInputFilter },
                          on: { click: _vm.clearFilterFields },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("creation_forms.clear_label")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2 d-none d-xl-inline",
                          attrs: { size: "sm", disabled: !_vm.hasInputFilter },
                          on: { click: _vm.clearFilterFields },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("filter.clr_fltr_field")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }